import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { leadershipMembers } from "@/data/leadership";

export default function LeadershipPage() {
  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <Navbar />

      <section className="pt-36 pb-20 px-6 bg-[#F8F6F3]">
        <div className="max-w-[1280px] mx-auto">
          <span className="inline-block text-[#C9A961] text-xs font-semibold uppercase tracking-widest mb-4">
            Management & Advisory Team
          </span>
          <h1 className="font-['Cormorant_Garamond'] text-5xl md:text-6xl font-bold text-[#2B2D2F] mb-5">
            Leadership Named in the Business Plan
          </h1>
          <p className="text-[#6B6B6B] text-lg max-w-3xl font-light leading-relaxed">
            This page reflects the management and advisory team identified in the Harambe Global Ventures business plan, aligning the public site with the plan&apos;s stated leadership structure.
          </p>
        </div>
      </section>

      <section className="py-24 px-6 bg-white">
        <div className="max-w-[1280px] mx-auto grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
          {leadershipMembers.map((member) => (
            <article key={member.name} className="bg-[#F8F6F3] border border-[#E8E4DC] rounded-lg overflow-hidden">
              <div className="aspect-square overflow-hidden">
                <img
                  src={member.img}
                  alt={member.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-7">
                <h2 className="font-['Cormorant_Garamond'] text-2xl font-bold text-[#2B2D2F] mb-1">
                  {member.name}
                </h2>
                <p className="text-[#1A4D3C] text-sm font-semibold mb-3">{member.title}</p>
                <p className="text-[#C9A961] text-xs uppercase tracking-[0.2em] mb-4">{member.location}</p>
                <p className="text-[#6B6B6B] text-sm leading-relaxed">{member.bio}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
}
